import styled from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

import { Button } from 'components/Button';

// Structural copy of components/Modal/Modal.styles.ts's centered-box variant
// (Container/Box/BoxInner), kept local to this feature on purpose — see
// SupportTicketModal.tsx for why. Only CloseButton's own look differs from
// the shared Modal's (bigger, more padding — feedback from manual QA).
const Container = styled.div`
  position: fixed;

  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  background-color: rgba(0, 0, 0, 0.5);

  z-index: 9999999999;
`;

const Box = styled.div`
  position: absolute;

  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  // A long description (near the 1000-char cap) plus several screenshot
  // previews can genuinely exceed the viewport height — without a cap here
  // the box just grows past both the top and bottom edges with nothing to
  // scroll it (reported: "тупо випадає віджет за екран і ніякої прокрутки").
  // "overflow: hidden" only clips to the rounded corners — BoxInner below is
  // the actual scroll container, so this element's own height never exceeds
  // the cap in the first place.
  max-height: 90vh;
  max-width: 90vw;

  background-color: ${pickColor('white')};
  border-radius: ${({ theme }) => theme.borderRadius.big};

  overflow: hidden;
`;

// Scrolls internally once content exceeds Box's max-height. The close
// button lives outside this element (a sibling in Box, not a child here) so
// it stays put at the top-right instead of scrolling away with a long form.
const BoxInner = styled.div`
  position: relative;

  max-height: 90vh;
  // Own padding on top of Form's (SupportTicketWidget.styles.ts) — Form's
  // is asymmetric (3rem/2rem) and only ever spaces its own fields, so the
  // modal box itself had zero breathing room around it on any side (user
  // feedback, 2026-09-24: "додай падінгу модалці з усіх сторін"). This is
  // the modal-level margin; CloseButton stays anchored to Box (its
  // positioned ancestor), so it's unaffected by this padding.
  padding: 1.6rem;

  overflow-y: auto;

  // Hides the scrollbar itself while leaving scrolling fully working (user
  // feedback, 2026-09-24) — same technique already used by
  // components/Dropdown/Dropdown.styles.ts's own ScrollArea.
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

const CloseButton = styled(Button)`
  position: absolute;

  top: 0.9rem;
  right: 2.4rem;

  padding: 0.6rem;

  font-size: 2rem;

  z-index: 9;
`;

export { Container, Box, BoxInner, CloseButton };
